module.exports = __webpack_public_path__ + "img/logo.1569610a.png";